
export const APP_CODE = import.meta.env.APP_CODE
export const APP_NAME = import.meta.env.APP_NAME
export const APP_COMP = import.meta.env.APP_COMP
export const APP_MODE = import.meta.env.MODE
export const APP_VERSION = import.meta.env.APP_VERSION

export const APP_URL = import.meta.env.APP_GUI_URL
export const API_URL = import.meta.env.APP_URL

export const API_COOKIE_MAIN = import.meta.env.APP_COOKIE_MAIN ?? ""

export const APP_LOG_SENTRY = import.meta.env.APP_LOG_SENTRY
